"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ScriptsRegistryContext = exports.ScriptsRegistry = void 0;

var React = _interopRequireWildcard(require("react"));

var _loadScript = _interopRequireWildcard(require("./loadScript"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ScriptsRegistry {
  constructor() {
    _defineProperty(this, "scripts", []);

    _defineProperty(this, "results", {});

    _defineProperty(this, "promises", {});
  }

  scriptTags() {
    return this.scripts.map(props => React.createElement("script", _extends({
      key: props.src
    }, props)));
  }

}

exports.ScriptsRegistry = ScriptsRegistry;
const ScriptsRegistryContext = React.createContext(null);
exports.ScriptsRegistryContext = ScriptsRegistryContext;

class ScriptLoader extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "mounted", false);

    _defineProperty(this, "promise", (0, _loadScript.default)(this.props));

    _defineProperty(this, "state", (0, _loadScript.getState)(this.props));
  }

  componentDidMount() {
    this.mounted = true;
    this.listenTo(this.promise);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate() {
    const promise = (0, _loadScript.default)(this.props);

    if (this.promise !== promise) {
      this.setState((0, _loadScript.getState)(this.props));
      this.promise = promise;
      this.listenTo(promise);
    }
  }

  listenTo(promise) {
    const {
      props
    } = this;
    const {
      onLoad,
      onError
    } = props;
    promise.then(() => {
      if (!this.mounted || this.promise !== promise) return;
      if (onLoad) onLoad();
      this.setState((0, _loadScript.getState)(props));
    }, error => {
      if (!this.mounted || this.promise !== promise) return;
      if (onError) onError(error);
      this.setState((0, _loadScript.getState)(props));
    });
  }

  render() {
    const {
      children
    } = this.props;

    if (children) {
      const result = children(_objectSpread({}, this.state));
      return result == null ? null : result;
    }

    return null;
  }

}

_defineProperty(ScriptLoader, "propTypes", {
  src: _propTypes.default.string.isRequired,
  onLoad: _propTypes.default.func,
  onError: _propTypes.default.func,
  children: _propTypes.default.func
});

const ConnectedScriptsLoader = props => React.createElement(ScriptsRegistryContext.Consumer, null, scriptsRegistry => React.createElement(ScriptLoader, _extends({}, props, {
  scriptsRegistry: scriptsRegistry
})));

var _default = ConnectedScriptsLoader;
exports.default = _default;